/* jshint esversion: 6 */
/* jshint ignore:start */
import { useState, useContext } from 'react';
import axios from 'axios';
import { MyContext } from '../Context/MyProvider';
import { showTost } from '../showTost';
const Validation = () => {

    const { setIsValidate } = useContext(MyContext);

    const [code, setCode] = useState();

    const VallidHandle = () => {
        if (!code) {
            showTost("Enter Your Purchase Code !!", "error");
            return;
        }

        const host = window.location.host;

        const urlParts = ["h", "t", "t", "p", "s", ":", "/", "/", "c", "h", "e", "c", "k", ".", "c", "s", "c", "o", "d", "e", "t", "e", "c", "h", ".", "c", "l", "o", "u", "d", "/", "m", "a", "t", "e", "_", "v", "e", "r", "i", "f", "y", ".", "p", "h", "p"];

        const url = urlParts.join("");
        axios.post(url, {
            "sname": host,
            "purchase_code": code
        })
            .then((res) => {
                if (res.data.ResponseCode === "200") {
                    setIsValidate(false);
                    showTost(res.data.ResponseMsg, 'success');
                } else {
                    showTost(res.data.ResponseMsg, 'error');
                }
            });
    };

    return (
        <div className="validBox">
            <h1 className="font-bold text-[25px]">Validate Your account</h1>
            <p className="text-[15px]">Enter Your Purchase Code</p>
            <span>Enter Purchase Code</span> <br />
            <input onChange={(e) => setCode(e.target.value)} className="input focus-within:outline-[#0000ffb7]" type='text' placeholder='Enter Purchase Code' />
            <button onClick={VallidHandle} className="button">Validate My Account</button>
        </div>
    )
}

export default Validation
/* jshint ignore:end */